import React from 'react'

import { Divider, Typography } from 'antd'
import { Link } from 'react-router-dom'

const { Title } = Typography

class FAQ extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div>
        <Title>FAQs</Title>
        <h4>PREPARE TO SELL AND LICENSE</h4>
        <Divider orientation='left' />
        <div>
          1.Manage Artworks
          <ul>
            <li style={{ marginTop: 6 }}>
              <Link to={'/sam/faqs/' + '1.1-Add+Edit+Delete'} target='_blank'>
                1.1 Add/Edit/Delete
              </Link>
            </li>
            <li style={{ marginTop: 6 }}>
              <Link to={'/sam/faqs/' + '1.2-Inventory+Report'} target='_blank'>
                1.2 Inventory Report
              </Link>
            </li>
            <li style={{ marginTop: 6 }}>
              <Link to={'/sam/faqs/' + '1.3-Bulk+Uploads'} target='_blank'>
                1.3 Bulk Uploads
              </Link>
            </li>
          </ul>
        </div>
        <Divider orientation='left' />

        <Link to={'/sam/faqs/' + '2.-Manage+The+Showcase'} target='_blank'>
          2.Manage The Showcase
        </Link>
        <Divider orientation='left' />
        <Link to={'/sam/faqs/' + '3.-Manage+Agreements'} target='_blank'>
          3.Manage Agreements
        </Link>
        <Divider orientation='left' />
        <Link to={'/sam/faqs/' + '4.-Troubleshooting'} target='_blank'>
          4.Troubleshooting
        </Link>
        <Divider orientation='left' />
        <Link to={'/sam/faqs/' + '5.-Participate+In+Print+Business'} target='_blank'>
          5.Participate In Print Business
        </Link>
      </div>
    )
  }
}

export default FAQ
